import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from 'src/components/ui/popover';
import { Separator } from 'src/components/ui/separator';
import { DeleteProjectModal } from 'src/pages/ProjectPage/ProjectInfoSection/DeleteProjectModal';
import { clsx } from 'clsx';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { ROLES } from 'src/constants/roles';
import { ChangeProjectNameModal } from 'src/components/HomePageComponents/ChangeProjectNameModal/ChangeProjectNameModal';
import { Button } from 'src/components/ui/button';

const TriggerSvg = () => {
  return (
    <svg width="4" height="20" viewBox="0 0 4 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="1.99997" cy="1.99997" r="1.99997" fill="#05050D" fillOpacity="0.3" />
      <circle cx="1.99997" cy="10.0001" r="1.99997" fill="#05050D" fillOpacity="0.3" />
      <circle cx="1.99997" cy="18" r="1.99997" fill="#05050D" fillOpacity="0.3" />
    </svg>
  );
};

export const SettingsPopover = ({ project }) => {
  const [open, setOpen] = React.useState(false);

  const { data: userInfo } = useGetUsersMeQuery();

  const isCosupportManager =
    userInfo?.role === ROLES.COSSUPORT_MANAGER || userInfo?.role === ROLES.ADMIN;

  return (
    <Popover modal={false} open={open} onOpenChange={(openState) => setOpen(openState)}>
      <PopoverTrigger
        asChild
        onClick={(e) => {
          e.preventDefault();
          setOpen((prev) => !prev);
        }}
      >
        <Button variant="ghost">
          <TriggerSvg />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        onClick={(e) => e.preventDefault()}
        align="end"
        className="min-w-[170px] shadow transition backdrop-blur rounded-sm-5 w-max h-max px-0 py-0 flex flex-col "
      >
        <ul>
          <li>
            <ChangeProjectNameModal
              setOpenModal={setOpen}
              project={project}
              trigger={
                <button
                  className={clsx(
                    !isCosupportManager && 'pointer-events-none',
                    'w-full pt-4 [&_p]:hover:opacity-80',
                  )}
                >
                  <p className="text-center font-jamjuree font-semibold text-sm opacity-50 transition">
                    Rename
                  </p>
                  <Separator className={'bg-[#E3E6E8] mt-4'} />
                </button>
              }
            />
          </li>
          <li>
            <button
              disabled={true}
              className={clsx(
                'pointer-events-none opacity-50',
                'w-full pt-4 [&_p]:hover:opacity-80',
              )}
            >
              <p className="text-center opacity-50 transition font-jamjuree font-semibold text-sm">
                Duplicate
              </p>
              <Separator className={'bg-[#E3E6E8] mt-4'} />
            </button>
          </li>
          <li>
            <DeleteProjectModal
              setOpenModal={setOpen}
              project={project}
              redirect={false}
              trigger={
                <button
                  className={clsx(
                    !isCosupportManager && 'pointer-events-none opacity-50 px-5',
                    'w-full py-4 [&_p]:hover:opacity-80',
                  )}
                >
                  <p className="text-center text-delete opacity-50 transition font-jamjuree font-semibold text-sm">
                    Delete
                  </p>
                </button>
              }
              disabled={!isCosupportManager}
            />
            {!isCosupportManager && (
              <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
            )}
          </li>
        </ul>
      </PopoverContent>
    </Popover>
  );
};
